import { getBaseApi } from "../api";
import type { Invitation } from "../types";

const api = getBaseApi();

export const createInvitation = async (data: Invitation) => {
  const response = await api.post('/invitations', data);
  return response.data?.data;
};

export const deleteInvitation = async (id: string) => {
  const response = await api.delete(`/invitations/${id}`);
  return response.data?.data;
};